import { render, staticRenderFns } from "./editCustomEvent.vue?vue&type=template&id=765993ba&"
import script from "./editCustomEvent.vue?vue&type=script&lang=js&"
export * from "./editCustomEvent.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports